import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

export function AsideCard({ children, className }) {
  const cardClassNames = classNames('aside-card', className);

  return <div className={cardClassNames}>{children}</div>;
}

AsideCard.defaultProps = {
  className: '',
};

AsideCard.propTypes = {
  children: propTypes.oneOfType([propTypes.element, propTypes.node]).isRequired,
  className: propTypes.string,
};
